import React from "react";
import {useDispatch} from "react-redux";
import {toggleSidebarMode, startNewChat} from "../../slice/chat.slice";
import {Config} from "../../config";
import {CloseIcon, SidebarIcon, FloatIcon} from "./icons";

const CloseButton = ({onClick }) => (
    <button
        className="sb-chat--header_btn sb-chat--header_close-btn"
        type="button"
        aria-label="Close chat"
        onClick={onClick}
    >
        <CloseIcon />
    </button>
);

const ToggleSidebarButton = ({ sidebarMode, onClick }) => (
    <button
        className="sb-chat--header_btn sb-chat--header_btn-tooltip sb-chat--header_toggle-btn"
        type="button"
        aria-label={sidebarMode ? "Switch to full page mode" : "Switch to sidebar"}
        onClick={onClick}
    >
        {sidebarMode ? <FloatIcon /> : <SidebarIcon />}
        <span className={'sb-chat--header_btn-txt'}>
            {sidebarMode ? 'Full page mode' : 'Sidebar mode' }
        </span>
    </button>
);

const NewChatButton = ({ onClick }) => (
    <button
        className="sb-chat--header_btn sb-chat--header_btn-tooltip sb-chat--header_new-chat-btn"
        type="button"
        aria-label="Start new chat"
        onClick={onClick}
    >
        <NewChatIcon />
        <span className={'sb-chat--header_btn-txt'}>Start new chat</span>
    </button>
);

const NewChatIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill={"currentColor"} d="M144 464.2C150.2 452.8 148.9 438.8 140.8 428.8C112.6 393.9 96 350.7 96 304C96 191 194.3 96 320 96C445.7 96 544 191 544 304C544 417 445.7 512 320 512C287.7 512 257.2 505.7 229.6 494.4C221.7 491.1 212.7 491.2 204.8 494.6L103.8 537.8L144 464.2zM64 304C64 358.4 83.3 408.6 115.9 448.9L67.1 538.3C65.1 542 64 546.2 64 550.5C64 564.6 75.4 576 89.5 576C93.5 576 97.3 575.4 101 573.9L217.4 524C248.8 536.9 283.5 544 320 544C461.4 544 576 436.5 576 304C576 171.5 461.4 64 320 64C178.6 64 64 171.5 64 304zM304 376C304 384.8 311.2 392 320 392C328.8 392 336 384.8 336 376L336 320L392 320C400.8 320 408 312.8 408 304C408 295.2 400.8 288 392 288L336 288L336 232C336 223.2 328.8 216 320 216C311.2 216 304 223.2 304 232L304 288L248 288C239.2 288 232 295.2 232 304C232 312.8 239.2 320 248 320L304 320L304 376z"/></svg>
);

export const ChatHeader = ({ onClose, inlineMode, sidebarMode, onDragStart }) => {
    const dispatch = useDispatch();
    const config = Config.getInstance();
    const onToggle = () => dispatch(toggleSidebarMode());
    const onNewChat = () => dispatch(startNewChat());

    return (
        <div className={'sb-chat--header'} onMouseDown={onDragStart || undefined}>
            {config.is_admin ? <h3 className={'sb-chat--header_title'}>Simply AI Assistant <span>Beta</span></h3> : <h3 className={'sb-chat--header_title'}>Booking AI assistant</h3>}
            {config.is_admin && <NewChatButton onClick={onNewChat} />}
            {!inlineMode && <ToggleSidebarButton sidebarMode={sidebarMode} onClick={onToggle} />}
            {(!inlineMode || sidebarMode) && <CloseButton onClick={onClose} />}
        </div>
    );
};
